import {action, observable, onBecomeObserved, onBecomeUnobserved} from 'mobx';

import type {ObservableElement} from './ObservableElement';

export default class ObservableElementImpl implements ObservableElement {
  @observable.ref private accessor _scrollWidth: number;
  private readonly _stack?: DisposableStack;

  constructor(private readonly _element: HTMLElement) {
    this._scrollWidth = _element.scrollWidth;

    if ('ResizeObserver' in window) {
      using stack = new DisposableStack();
      const resizeObserver = new ResizeObserver(
        action(() => {
          this._scrollWidth = _element.scrollWidth;
        }),
      );
      stack.defer(
        onBecomeObserved(this, '_scrollWidth', () => {
          resizeObserver.observe(_element);
        }),
      );
      stack.defer(
        onBecomeUnobserved(this, '_scrollWidth', () => {
          resizeObserver.unobserve(_element);
        }),
      );
      stack.defer(() => {
        resizeObserver.disconnect();
      });
      this._stack = stack.move();
    }
  }

  get scrollWidth() {
    Reflect.get(this, '_scrollWidth', this);
    return this._element.scrollWidth;
  }

  [Symbol.dispose]() {
    return this._stack?.dispose();
  }
}
